import { ShowToast } from "@Components/ToastNotification/ToastNotification"
import { REFECTH_QUERY_INTERVAL, message } from "@Constants/constant"
import { userAtom } from "@Recoil/Atom/userAtom"
import { EventService } from "@Services/Event.Service"
import { useQuery } from "@tanstack/react-query"
import { useRecoilValue } from "recoil"

function useUserAppointmentRQHooks() {
    const user = useRecoilValue(userAtom)

    return useQuery({
        queryKey: [`entretiens`],
        queryFn: async () => await EventService.GetUsersIndividualEvents(user?.id),
        onSuccess: () => {},
        onError: () => {
            ShowToast({ type: "error", message: message.serverError })
        },
        select: (responses) => {
            const data = responses?.data?.data
            return data
        },
        refetchInterval: REFECTH_QUERY_INTERVAL + 2500
    })
}

export { useUserAppointmentRQHooks }
